<div class="sales-split-card">
  <div class="split-total">
    <p class="split-total-label">{{ totalLabelKey | translate }}</p>
    <p class="split-total-value">{{ totalAmountLabel }}</p>
  </div>
  @if (rows.length) {
  <div class="split-bar">
    @for (row of rows; track row.labelKey) {
    <span class="split-bar-segment" [style.width.%]="row.percent" [style.background]="row.color"></span>
    }
  </div>
  <div class="split-rows">
    @for (row of rows; track row.labelKey) {
    <div class="split-row">
      <span class="split-row-dot" [style.background]="row.color"></span>
      <span class="split-row-label">{{ row.labelKey | translate }}</span>
      <span class="split-row-amount">{{ row.amount | arsCurrency }}</span>
      <span class="split-row-percent">{{ row.percent }}%</span>
    </div>
    }
  </div>
  }
</div>
